<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-row class="justify-content-between align-items-end">
          <b-col class="col-3">
            <AppSearchInput
              :label="$t('search') + ':'"
              :placeholder="$t('search') + '...'"
              @callback="onFiltered"
            />
          </b-col>

          <b-col class="col ml-auto text-right">
            <b-form-radio-group
              v-model="card"
              class="mb-1 list item-view-radio-group"
              buttons
              button-variant="outline-primary"
            >
              <b-form-radio
                v-for="option in itemViewOptions"
                :key="option.value"
                :value="option.value"
                @input="() => { timeline = false }"
              >
                {{ option.text }}
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col
            v-if="card"
            class="col-md-12"
          >
            <b-card>
              <h6 class="mb-1">
                {{$t('raw_materials')}} / {{$t('reference.material')}}:
              </h6>
              <material-table
                @row-selected="onSelected"
                @on-click-pto="onPtoClicked"
                @on-click-reset="onReset"
              />
              <Pagination
                :nobody="true"
                :params="filter"
                @refresh="refresh"
              />
            </b-card>
          </b-col>

          <b-col
            v-else
            class="col-md-12"
          >
            <b-card>
              <h6 class="mb-1">
                {{$t('reference.instrument')}}
              </h6>
              <instruments-table
                @row-selected="onSelected"
                @on-click-reset="onReset"
              />
              <Pagination
                :nobody="true"
                :params="filterInstrument"
                @refresh="refresh"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        v-if="timeline"
        class="col-md-3"
      >
        <b-card class="h-100">
          <app-timeline>
            <app-timeline-item
              title="Goal Achieved"
              subtitle="All milestones are completed"
              icon="AwardIcon"
              time="few minutes ago"
              variant="success"
            />

            <app-timeline-item
              title="Last milestone remain"
              subtitle="You are just one step away from your goal"
              icon="InfoIcon"
              time="3 minutes ago"
              variant="info"
            />

            <app-timeline-item
              title="Your are running low on time"
              subtitle="Only 30 minutes left to finish milestone"
              icon="ClockIcon"
              time="21 minutes ago"
              variant="warning"
            />

            <app-timeline-item
              title="Client Meeting"
              subtitle="New event has been added to your schedule"
              icon="UserIcon"
              time="36 minutes ago"
            />

            <app-timeline-item
              title="Product Design"
              subtitle="Product design added in workflow"
              icon="GridIcon"
              time="1 hour ago"
              variant="success"
            />
          </app-timeline>
        </b-card>
      </b-col>
    </b-row>

    <!-- <materialModal /> -->
    <!-- <instrumentModal /> -->
    <input-quantity-modal
      :data="dataForSend"
      :is-pto="isPto"
      @onSend="onSend"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormRadio,
  BFormRadioGroup,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import { mapActions } from 'vuex'
// import materialModal from './materialModal.vue'
// import instrumentModal from './instrumentModal.vue'
import AppSearchInput from '@/components/AppSearchInput.vue'
import InstrumentsTable from './tables/InstrumentsTable.vue'
import MaterialTable from './tables/MaterialTable.vue'
import Pagination from '@/components/Pagination.vue'
import InputQuantityModal from './InputQuantityModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    // materialModal,
    // instrumentModal,
    AppTimeline,
    AppTimelineItem,
    AppSearchInput,
    InstrumentsTable,
    MaterialTable,
    BFormRadio,
    BFormRadioGroup,
    Pagination,
    InputQuantityModal,
  },
  data() {
    return {
      card: true,
      isPto: true,
      timeline: false,
      filter: {
        page_size: 10,
        page: 1,
        object: this.$route.params.id,
      },
      filterInstrument: {
        page_size: 10,
        page: 1,
        object: this.$route.params.id,
      },
      dataForSend: {},
      itemViewOptions: [
        {
          text: this.$t('reference.material'),
          value: true,
        },
        {
          text: this.$t('reference.instrument'),
          value: false,
        },
      ],
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.refresh()
    }
  },
  methods: {
    ...mapActions('instruments', ['FETCH_INSTRUMENTS_MODEL_VARIANT']),
    ...mapActions('materials', ['FETCH_MATERIALS_TABLE_ID']),
    ...mapActions('application', ['CREATE_APPLICATION_GOOD_RETURN', 'CREATE_APPLICATION_INSTRUMENT_RETURN']),
    ...mapActions('pto', ['CREATE_PTO_FOR_GOOD']),
    // фильтр данных
    onFiltered(value) {
      if (this.card) {
        this.filter.search = value
        this.FETCH_MATERIALS_TABLE_ID(this.filter)
      } else {
        this.filterInstrument.search = value
        this.FETCH_INSTRUMENTS_MODEL_VARIANT(this.filterInstrument)
      }
    },
    refresh() {
      this.FETCH_MATERIALS_TABLE_ID(this.filter)
      this.FETCH_INSTRUMENTS_MODEL_VARIANT(this.filterInstrument)
    },
    // создание приказа
    onPtoClicked(data) {
      this.isPto = true
      const { id, remainder, ...rest } = data
      this.dataForSend = {
        good: id,
        remainder,
        ...rest,
      }
      this.$nextTick(() => {
        this.$bvModal.show('PtoModal')
      })
    },
    onSend(e) {
      if (this.isPto) {
        this.CREATE_PTO_FOR_GOOD({
          good: this.dataForSend.good,
          quantity: e,
        })
          .then(() => {
            this.$bvModal.hide('PtoModal')
            this.$_okToast()
          })
          .catch(() => {
            this.$_errToast('Error')
          })
        return
      }
      console.log(this.dataForSend)
      const data = {
        is_return: true,
        from_storage: this.$route.params.id,
      }
      if (this.card) {
        data.goods = [{
          good_id: this.dataForSend.good,
          count: e,
        }]
      } else {
        data.instruments = [{
          instrument_id: this.dataForSend.good,
          count: e,
        }]
      }
      (this.card ? this.CREATE_APPLICATION_GOOD_RETURN : this.CREATE_APPLICATION_INSTRUMENT_RETURN)(data)
        .then(() => {
          this.$bvModal.hide('PtoModal')
          this.$_okToast()
        })
        .catch(() => {
          this.$_errToast('error')
        })
    },
    onSelected() {
      this.timeline = true
    },
    onReset(event) {
      this.isPto = false
      const { id, remainder, ...rest } = event
      this.dataForSend = {
        good: id,
        remainder,
        ...rest,
      }
      this.$nextTick(() => {
        this.$bvModal.show('PtoModal')
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

//  кнопка переключения между заявками и инструментами
[dir] .btn-outline-primary:not(:disabled):not(.disabled).active {
  background-color: #5a9cd9;
  color: white;
}
</style>
